import { Component } from '@opten/gin-tonic/helpers/compiler';
import { A11y, Autoplay, default as Swiper, default as SwiperCore, EffectFade, Keyboard, Pagination, Parallax } from 'swiper';
import 'swiper/css/bundle';

SwiperCore.use([Pagination, A11y, EffectFade, Keyboard, Autoplay, Parallax]);

@Component({ className: 'js-hero' })
export class HeroComponent {
	private swiper;

	constructor(private element: HTMLElement) {
		this.swiper = new Swiper(element, {
			loop: true,
			initialSlide: 0,
			speed: 600,
			effect: 'fade',
			parallax: true,
			allowTouchMove: false,
			autoplay: {
				delay: 10000,
				disableOnInteraction: true
			},
			on: {
				init: function () {
					this.el.classList.remove('is-loading');
					this.pagination.bullets[0].classList.remove('c-hero__page--active');
					this.autoplay.start();
					setTimeout(() => {
						this.pagination.bullets[0].classList.add('c-hero__page--active');
					}, 0);
				}
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				bulletClass: 'c-hero__page',
				bulletActiveClass: 'c-hero__page--active',
				renderBullet: this.renderPagination.bind(this)
			}
		});
	}

	private renderPagination(index, className) {
		const slide = this.element.swiper.slides[index];
		return (
			'<div class="' +
			className +
			'">' +
			'<span class="c-hero__page__name d-none d-lg-block">' +
			slide.getAttribute('data-slide-title') +
			'</span>' +
			'<span class="c-text u-font-weight-bold d-none d-lg-block">' +
			slide.getAttribute('data-slide-desc') +
			'</span>' +
			'</div>'
		);
	}
}
